import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/LoginView.vue'
import HomeView from '../views/HomeView.vue'
import OpenNewWindowView from '../views/OpenNewWindowView.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomeView',
    component: HomeView
  },
  {
    path: '/login',
    name: 'LoginView',
    component: LoginView
  },
  {
    path: '/openNewWindow',
    name: 'OpenNewWindowView',
    component: OpenNewWindowView
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
import { confirmSignIn } from '@/mixins/index.js'
router.beforeEach(async (to, from, next) => {
  const isSignIn = await confirmSignIn()
  console.log('isSignIn', isSignIn)
  if (to.path === '/login') {
    if(isSignIn){
      next('/');
    }
    next();
  } else if (to.path === '/openNewWindow') {
    next();
  } else if (isSignIn) {
    next();
  } else {
    next('/login');
  }
});

export default router
